// Mock данные для сайта "Народные теплицы"

export const products = [
  // Теплица Стандарт
  {
    id: 1,
    name: "Теплица 'Стандарт' 3x4 м",
    slug: "teplica-standart-3x4",
    category: "standart",
    price: 20000,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 4, height: 2.1 },
    frame: "Оцинкованная труба 20x20 мм",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 3,
    inStock: true,
    isHit: true,
    isNew: false,
    step: "1 метр",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica1.jpeg",
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica2.jpeg"
    ],
    description: "Теплица Стандарт - надёжное решение для дачников. Оцинкованная труба 20x20, шаг между дугами 1 метр. В комплекте: две двери, две форточки, двусторонние ручки на дверях, штыри для фиксации к грунту.",
    features: ["Оцинкованная труба 20x20", "Шаг дуг 1 метр", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  {
    id: 2,
    name: "Теплица 'Стандарт' 3x6 м",
    slug: "teplica-standart-3x6",
    category: "standart",
    price: 24000,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 6, height: 2.1 },
    frame: "Оцинкованная труба 20x20 мм",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 3,
    inStock: true,
    isHit: true,
    isNew: false,
    step: "1 метр",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica1.jpeg"
    ],
    description: "Теплица Стандарт 3x6 - оптимальный размер для семьи. Оцинкованная труба 20x20, шаг между дугами 1 метр.",
    features: ["Оцинкованная труба 20x20", "Шаг дуг 1 метр", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  {
    id: 3,
    name: "Теплица 'Стандарт' 3x8 м",
    slug: "teplica-standart-3x8",
    category: "standart",
    price: 28000,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 8, height: 2.1 },
    frame: "Оцинкованная труба 20x20 мм",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 3,
    inStock: true,
    isHit: false,
    isNew: false,
    step: "1 метр",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica1.jpeg"
    ],
    description: "Теплица Стандарт 3x8 - просторная теплица для большого урожая.",
    features: ["Оцинкованная труба 20x20", "Шаг дуг 1 метр", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  {
    id: 4,
    name: "Теплица 'Стандарт' 3x10 м",
    slug: "teplica-standart-3x10",
    category: "standart",
    price: 32000,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 10, height: 2.1 },
    frame: "Оцинкованная труба 20x20 мм",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 3,
    inStock: true,
    isHit: false,
    isNew: false,
    step: "1 метр",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica1.jpeg"
    ],
    description: "Теплица Стандарт 3x10 - максимальный размер в линейке Стандарт.",
    features: ["Оцинкованная труба 20x20", "Шаг дуг 1 метр", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  // Теплица Стандарт Усиленная
  {
    id: 5,
    name: "Теплица 'Стандарт Усиленная' 3x4 м",
    slug: "teplica-standart-usilennaya-3x4",
    category: "standart-usilennaya",
    price: 21500,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 4, height: 2.1 },
    frame: "Оцинкованная труба 20x20 мм усиленная",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 5,
    inStock: true,
    isHit: false,
    isNew: true,
    step: "65 см",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica2.jpeg"
    ],
    description: "Теплица Стандарт Усиленная - усиленная версия с шагом дуг 65 см. Оцинкованная труба 20x20, повышенная прочность конструкции.",
    features: ["Оцинкованная труба 20x20", "Шаг дуг 65 см (усиленная)", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  {
    id: 6,
    name: "Теплица 'Стандарт Усиленная' 3x6 м",
    slug: "teplica-standart-usilennaya-3x6",
    category: "standart-usilennaya",
    price: 26500,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 6, height: 2.1 },
    frame: "Оцинкованная труба 20x20 мм усиленная",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 5,
    inStock: true,
    isHit: false,
    isNew: true,
    step: "65 см",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica2.jpeg"
    ],
    description: "Теплица Стандарт Усиленная 3x6 - усиленная конструкция для надёжной эксплуатации.",
    features: ["Оцинкованная труба 20x20", "Шаг дуг 65 см (усиленная)", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  {
    id: 7,
    name: "Теплица 'Стандарт Усиленная' 3x8 м",
    slug: "teplica-standart-usilennaya-3x8",
    category: "standart-usilennaya",
    price: 31500,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 8, height: 2.1 },
    frame: "Оцинкованная труба 20x20 мм усиленная",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 5,
    inStock: true,
    isHit: false,
    isNew: false,
    step: "65 см",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica2.jpeg"
    ],
    description: "Теплица Стандарт Усиленная 3x8 - просторная усиленная теплица.",
    features: ["Оцинкованная труба 20x20", "Шаг дуг 65 см (усиленная)", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  {
    id: 8,
    name: "Теплица 'Стандарт Усиленная' 3x10 м",
    slug: "teplica-standart-usilennaya-3x10",
    category: "standart-usilennaya",
    price: 36500,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 10, height: 2.1 },
    frame: "Оцинкованная труба 20x20 мм усиленная",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 5,
    inStock: true,
    isHit: false,
    isNew: false,
    step: "65 см",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica2.jpeg"
    ],
    description: "Теплица Стандарт Усиленная 3x10 - максимальный размер усиленной серии.",
    features: ["Оцинкованная труба 20x20", "Шаг дуг 65 см (усиленная)", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  // Теплица Богатырь
  {
    id: 9,
    name: "Теплица 'Богатырь' 3x4 м",
    slug: "teplica-bogatyr-3x4",
    category: "bogatyr",
    price: 23500,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 4, height: 2.1 },
    frame: "Оцинкованная труба 25x25 мм усиленная",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 7,
    inStock: true,
    isHit: true,
    isNew: false,
    step: "65 см",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica1.jpeg"
    ],
    description: "Теплица Богатырь - мощная конструкция с трубой 25x25. Шаг дуг 65 см, выдерживает большие снеговые нагрузки.",
    features: ["Оцинкованная труба 25x25", "Шаг дуг 65 см (усиленная)", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  {
    id: 10,
    name: "Теплица 'Богатырь' 3x6 м",
    slug: "teplica-bogatyr-3x6",
    category: "bogatyr",
    price: 29500,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 6, height: 2.1 },
    frame: "Оцинкованная труба 25x25 мм усиленная",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 7,
    inStock: true,
    isHit: true,
    isNew: false,
    step: "65 см",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica1.jpeg"
    ],
    description: "Теплица Богатырь 3x6 - оптимальный размер для серьёзного урожая.",
    features: ["Оцинкованная труба 25x25", "Шаг дуг 65 см (усиленная)", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  {
    id: 11,
    name: "Теплица 'Богатырь' 3x8 м",
    slug: "teplica-bogatyr-3x8",
    category: "bogatyr",
    price: 35500,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 8, height: 2.1 },
    frame: "Оцинкованная труба 25x25 мм усиленная",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 7,
    inStock: true,
    isHit: false,
    isNew: false,
    step: "65 см",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica1.jpeg"
    ],
    description: "Теплица Богатырь 3x8 - большая и прочная.",
    features: ["Оцинкованная труба 25x25", "Шаг дуг 65 см (усиленная)", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  {
    id: 12,
    name: "Теплица 'Богатырь' 3x10 м",
    slug: "teplica-bogatyr-3x10",
    category: "bogatyr",
    price: 41500,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 10, height: 2.1 },
    frame: "Оцинкованная труба 25x25 мм усиленная",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 7,
    inStock: true,
    isHit: false,
    isNew: false,
    step: "65 см",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica1.jpeg"
    ],
    description: "Теплица Богатырь 3x10 - максимальный размер серии Богатырь.",
    features: ["Оцинкованная труба 25x25", "Шаг дуг 65 см (усиленная)", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  // Теплица Премиум
  {
    id: 13,
    name: "Теплица 'Премиум' 3x4 м",
    slug: "teplica-premium-3x4",
    category: "premium",
    price: 29000,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 4, height: 2.1 },
    frame: "Оцинкованная труба 40x20 мм усиленная",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 10,
    inStock: true,
    isHit: false,
    isNew: true,
    step: "65 см",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica2.jpeg"
    ],
    description: "Теплица Премиум - топовая модель с трубой 40x20. Максимальная прочность и долговечность.",
    features: ["Оцинкованная труба 40x20", "Шаг дуг 65 см (усиленная)", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  {
    id: 14,
    name: "Теплица 'Премиум' 3x6 м",
    slug: "teplica-premium-3x6",
    category: "premium",
    price: 37000,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 6, height: 2.1 },
    frame: "Оцинкованная труба 40x20 мм усиленная",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 10,
    inStock: true,
    isHit: false,
    isNew: true,
    step: "65 см",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica2.jpeg"
    ],
    description: "Теплица Премиум 3x6 - идеальный выбор для требовательных покупателей.",
    features: ["Оцинкованная труба 40x20", "Шаг дуг 65 см (усиленная)", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  {
    id: 15,
    name: "Теплица 'Премиум' 3x8 м",
    slug: "teplica-premium-3x8",
    category: "premium",
    price: 45000,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 8, height: 2.1 },
    frame: "Оцинкованная труба 40x20 мм усиленная",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 10,
    inStock: true,
    isHit: false,
    isNew: false,
    step: "65 см",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica2.jpeg"
    ],
    description: "Теплица Премиум 3x8 - просторная премиальная теплица.",
    features: ["Оцинкованная труба 40x20", "Шаг дуг 65 см (усиленная)", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  {
    id: 16,
    name: "Теплица 'Премиум' 3x10 м",
    slug: "teplica-premium-3x10",
    category: "premium",
    price: 53000,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 10, height: 2.1 },
    frame: "Оцинкованная труба 40x20 мм усиленная",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 10,
    inStock: true,
    isHit: false,
    isNew: false,
    step: "65 см",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica2.jpeg"
    ],
    description: "Теплица Премиум 3x10 - флагман линейки премиальных теплиц.",
    features: ["Оцинкованная труба 40x20", "Шаг дуг 65 см (усиленная)", "2 двери + 2 форточки", "Ручки двусторонние", "Штыри для фиксации"]
  },
  // Теплица Домиком - Прямостенная
  {
    id: 17,
    name: "Теплица 'Домиком' 3x4 м",
    slug: "teplica-domikom-3x4",
    category: "domikom",
    price: 32000,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 4, height: 2.3 },
    frame: "Сдвоенная труба 20х20 (Двойное усиление)",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 10,
    inStock: true,
    isHit: false,
    isNew: true,
    step: "1 метр",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica1.jpeg"
    ],
    description: "Прямостенная теплица с двускатной крышей. Сдвоенная труба 20х20 (Двойное усиление), шаг между дугами 1 метр. Увеличенная высота, удобство работы вдоль стен. Гарантия 10 лет*.",
    features: ["Сдвоенная труба 20х20 (Двойное усиление)", "Шаг дуг 1 метр", "Прямые стены", "Двускатная крыша", "Высота 2.3 м", "2 двери + 2 форточки"]
  },
  {
    id: 18,
    name: "Теплица 'Домиком' 3x6 м",
    slug: "teplica-domikom-3x6",
    category: "domikom",
    price: 42000,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 6, height: 2.3 },
    frame: "Сдвоенная труба 20х20 (Двойное усиление)",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 10,
    inStock: true,
    isHit: false,
    isNew: true,
    step: "1 метр",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica2.jpeg"
    ],
    description: "Прямостенная теплица Домиком 3x6 - оптимальный размер. Сдвоенная труба 20х20 (Двойное усиление), шаг между дугами 1 метр. Гарантия 10 лет*.",
    features: ["Сдвоенная труба 20х20 (Двойное усиление)", "Шаг дуг 1 метр", "Прямые стены", "Двускатная крыша", "Высота 2.3 м", "2 двери + 2 форточки"]
  },
  {
    id: 19,
    name: "Теплица 'Домиком' 3x8 м",
    slug: "teplica-domikom-3x8",
    category: "domikom",
    price: 52000,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 8, height: 2.3 },
    frame: "Сдвоенная труба 20х20 (Двойное усиление)",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 10,
    inStock: true,
    isHit: false,
    isNew: true,
    step: "1 метр",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica3.jpeg"
    ],
    description: "Прямостенная теплица Домиком 3x8 - для серьёзного выращивания. Сдвоенная труба 20х20 (Двойное усиление), шаг между дугами 1 метр. Гарантия 10 лет*.",
    features: ["Сдвоенная труба 20х20 (Двойное усиление)", "Шаг дуг 1 метр", "Прямые стены", "Двускатная крыша", "Высота 2.3 м", "2 двери + 2 форточки"]
  },
  {
    id: 20,
    name: "Теплица 'Домиком' 3x10 м",
    slug: "teplica-domikom-3x10",
    category: "domikom",
    price: 62000,
    oldPrice: null,
    discount: 0,
    size: { width: 3, length: 10, height: 2.3 },
    frame: "Сдвоенная труба 20х20 (Двойное усиление)",
    polycarbonate: "4 мм сотовый с UV-защитой",
    warranty: 10,
    inStock: true,
    isHit: false,
    isNew: true,
    step: "1 метр",
    images: [
      "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica4.jpeg"
    ],
    description: "Прямостенная теплица Домиком 3x10 - максимальный размер. Сдвоенная труба 20х20 (Двойное усиление), шаг между дугами 1 метр. Гарантия 10 лет*.",
    features: ["Сдвоенная труба 20х20 (Двойное усиление)", "Шаг дуг 1 метр", "Прямые стены", "Двускатная крыша", "Высота 2.3 м", "2 двери + 2 форточки"]
  }
];

export const categories = [
  { id: "all", name: "Все теплицы", count: 20 },
  { id: "standart", name: "Стандарт", count: 4, priceFrom: 20000, frame: "20x20", step: "1 м", description: "Оцинкованная труба 20x20, шаг дуг 1 м" },
  { id: "standart-usilennaya", name: "Стандарт Усиленная", count: 4, priceFrom: 21500, frame: "20x20", step: "65 см", description: "Оцинкованная труба 20x20, шаг дуг 65 см (усиленная)" },
  { id: "bogatyr", name: "Богатырь", count: 4, priceFrom: 23500, frame: "25x25", step: "65 см", description: "Оцинкованная труба 25x25, шаг дуг 65 см (усиленная)" },
  { id: "premium", name: "Премиум", count: 4, priceFrom: 29000, frame: "40x20", step: "65 см", description: "Оцинкованная труба 40x20, шаг дуг 65 см (усиленная)" },
  { id: "domikom", name: "Домиком - Прямостенная", count: 4, priceFrom: 32000, frame: "Сдвоенная 20x20", step: "1 метр", description: "Прямостенная теплица с двускатной крышей, сдвоенная труба 20х20" },
  { id: "custom", name: "Фермерские", count: 0, priceFrom: null }
];

export const promotions = [
  {
    id: 1,
    title: "Сезонная распродажа!",
    description: "Специальные цены на все модели теплиц",
    discount: 0,
    endDate: "2026-09-01",
    image: "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica2.jpeg",
    code: null
  },
  {
    id: 2,
    title: "Монтаж в подарок",
    description: "При заказе теплицы Премиум - профессиональный монтаж бесплатно",
    discount: 0,
    endDate: "2026-10-15",
    image: "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica1.jpeg",
    code: "MONTAZH"
  }
];

export const galleryItems = [
  {
    id: 1,
    title: "Теплица 'Богатырь' в Туймазах",
    location: "г. Туймазы",
    date: "Май 2023",
    image: "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica1.jpeg"
  },
  {
    id: 2,
    title: "Теплица 'Стандарт Усиленная' в Белебее",
    location: "г. Белебей",
    date: "Апрель 2022",
    image: "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica2.jpeg"
  },
  {
    id: 3,
    title: "Теплица 'Премиум' в Октябрьском",
    location: "г. Октябрьский",
    date: "Март 2025",
    image: "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica3.jpeg"
  },
  {
    id: 4,
    title: "Теплица 'Стандарт' в Бавлах",
    location: "г. Бавлы",
    date: "Июнь 2017",
    image: "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica4.jpeg"
  },
  {
    id: 5,
    title: "Комплекс из 2 теплиц в Азнакаево",
    location: "г. Азнакаево",
    date: "Май 2023",
    image: "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica1.jpeg"
  },
  {
    id: 6,
    title: "Теплица 'Богатырь' в Шаране",
    location: "с. Шаран",
    date: "Июль 2022",
    image: "https://polyhut-store.preview.emergentagent.com/api/uploads/teplica2.jpeg"
  }
];

export const blogPosts = [
  {
    id: 1,
    slug: "kak-vybrat-teplicu",
    title: "Как выбрать теплицу из поликарбоната: полное руководство",
    excerpt: "Разбираемся в типах теплиц, материалах каркаса и поликарбоната. Советы экспертов по выбору оптимального варианта для Башкортостана.",
    content: `
## Как выбрать теплицу из поликарбоната: полное руководство

Выбор теплицы — важное решение для каждого дачника. От правильного выбора зависит урожайность, долговечность конструкции и удобство эксплуатации. В этой статье мы расскажем, на что обратить внимание при покупке теплицы.

### 1. Тип каркаса

**Труба 20x20 мм** — базовый вариант для регионов с умеренным климатом. Подходит для небольших теплиц до 6 метров.

**Труба 25x25 мм** — усиленный каркас, выдерживает снеговую нагрузку до 180 кг/м². Рекомендуем для Башкортостана.

**Труба 40x20 мм** — профессиональный каркас с максимальной прочностью. Гарантия до 10 лет.

### 2. Шаг дуг

- **1 метр** — стандартный шаг, достаточный для большинства регионов
- **65 см** — усиленный шаг, рекомендуем для снежных зим

### 3. Поликарбонат

Плотность поликарбоната — главный показатель качества:
- **0.42 кг/м²** — эконом, срок службы 3-5 лет
- **0.52 кг/м²** — стандарт, оптимальный выбор
- **0.6 кг/м²** — усиленный, для снежных регионов
- **0.7 кг/м²** — премиум, максимальная прочность

### 4. Размер теплицы

Выбирайте размер исходя из ваших потребностей:
- **3x4 м** — для 2-3 грядок, семья из 2-3 человек
- **3x6 м** — оптимальный размер для семьи из 4-5 человек
- **3x8 м и более** — для серьёзного выращивания

### Наши рекомендации

Для Башкортостана и Татарстана мы рекомендуем теплицы серии **Богатырь** или **Премиум** с усиленным каркасом и поликарбонатом плотностью от 0.52 кг/м².
    `,
    image: "https://images.unsplash.com/photo-1696614243802-2a14f0e3b53f?w=800&q=80",
    date: "2025-07-15",
    category: "Советы",
    readTime: 8
  },
  {
    id: 2,
    slug: "uhod-za-teplicey",
    title: "Уход за теплицей: сезонные работы весной, летом и осенью",
    excerpt: "Как правильно ухаживать за теплицей в разные сезоны. Подготовка к зиме, весенняя обработка и летний уход в условиях Башкортостана.",
    content: `
## Уход за теплицей: сезонные работы

Правильный уход за теплицей — залог её долговечности и богатого урожая. Рассмотрим основные работы по сезонам.

### Весенние работы

**Март-апрель:**
- Очистите поликарбонат от загрязнений мягкой тряпкой с мыльным раствором
- Проверьте герметичность всех соединений
- Осмотрите каркас на предмет коррозии (для оцинкованных труб это редкость)
- Подготовьте почву: перекопайте, внесите удобрения

**Май:**
- Проветривайте теплицу днём
- Установите термоприводы на форточки для автоматического проветривания
- Проверьте работу дверей

### Летние работы

- **Полив:** Лучше утром или вечером, избегайте полива в жару
- **Проветривание:** Открывайте двери и форточки в жаркие дни
- **Притенение:** При температуре выше 30°C используйте сетку или побелку
- **Подвязка растений:** Используйте шпалеры и подвязки

### Осенние работы

**Сентябрь-октябрь:**
- Уберите растительные остатки
- Продезинфицируйте почву
- Очистите поликарбонат
- Проверьте все крепления

### Подготовка к зиме

В условиях Башкортостана важно:
- **Усильте каркас** подпорками, если снеговая нагрузка высокая
- **Очистите снег** с крыши при накоплении более 20 см
- Теплицы с шагом дуг 65 см и трубой 25x25 или 40x20 выдерживают нагрузку самостоятельно
    `,
    image: "https://images.unsplash.com/photo-1639247306848-76a60ff8d54e?w=800&q=80",
    date: "2025-07-10",
    category: "Уход",
    readTime: 6
  },
  {
    id: 3,
    slug: "vyrashchivanie-tomatov",
    title: "Выращивание томатов в теплице: от рассады до урожая",
    excerpt: "Пошаговая инструкция по выращиванию томатов в теплице. Выбор сортов для Башкортостана, посадка, уход, полив и сбор урожая.",
    content: `
## Выращивание томатов в теплице: полное руководство

Томаты — одна из самых популярных культур для выращивания в теплице. В условиях Башкортостана теплица позволяет получить урожай на 2-3 недели раньше и продлить сезон до октября.

### Выбор сортов для теплицы

**Индетерминантные (высокорослые):**
- Бычье сердце — крупные, мясистые плоды
- Де Барао — урожайные, устойчивые к болезням
- Черри — мелкие сладкие плоды

**Детерминантные (низкорослые):**
- Санька — раннеспелый, неприхотливый
- Ляна — розовые плоды, отличный вкус

### Подготовка рассады

1. **Сроки посева:** конец февраля — начало марта
2. **Температура прорастания:** 22-25°C
3. **Пикировка:** при появлении 2-3 настоящих листьев
4. **Закаливание:** за 2 недели до высадки

### Высадка в теплицу

- **Сроки:** середина мая (для Башкортостана)
- **Схема посадки:** 40x60 см для детерминантных, 50x70 см для индетерминантных
- **Глубина:** до первых настоящих листьев

### Уход за томатами

**Полив:**
- 2-3 раза в неделю
- Под корень, избегая попадания на листья
- Лучше утром

**Подкормка:**
- Первая — через 2 недели после высадки
- Затем — каждые 2 недели до начала созревания

**Пасынкование:**
- Удаляйте боковые побеги в пазухах листьев
- Формируйте в 1-2 стебля

### Сбор урожая

Собирайте томаты в стадии технической спелости (начало покраснения) — они дозреют дома и будут храниться дольше.
    `,
    image: "https://images.unsplash.com/photo-1599663371158-b5d9ae173108?w=800&q=80",
    date: "2025-07-05",
    category: "Выращивание",
    readTime: 10
  },
  {
    id: 4,
    slug: "montazh-teplicy",
    title: "Монтаж теплицы своими руками: пошаговая инструкция",
    excerpt: "Подробная инструкция по самостоятельной сборке теплицы из поликарбоната. Необходимые инструменты, подготовка площадки и пошаговое руководство.",
    content: `
## Монтаж теплицы своими руками

Сборка теплицы из поликарбоната — задача, которую можно выполнить самостоятельно за 1-2 дня. Следуйте нашей инструкции для правильной установки.

### Необходимые инструменты

- Шуруповёрт с набором бит
- Уровень строительный
- Рулетка
- Ключи (10, 13 мм)
- Нож для поликарбоната

### Подготовка площадки

1. **Выберите место:** солнечное, защищённое от ветра
2. **Выровняйте площадку:** перепад высот не более 5 см
3. **Подготовьте фундамент:**
   - Брус 100x100 мм (мы поставляем готовый комплект)
   - Или бетонные блоки
   - Или заглубление в грунт на штыри

### Пошаговая сборка

**Шаг 1: Сборка торцов**
- Соберите торцевые секции с дверями и форточками
- Установите петли и ручки

**Шаг 2: Установка основания**
- Соедините продольные балки с торцами
- Выровняйте по уровню
- Закрепите к фундаменту

**Шаг 3: Монтаж дуг**
- Установите дуги с шагом согласно модели
- Закрепите на продольных направляющих

**Шаг 4: Крепление поликарбоната**
- Уложите листы с защитой UV-слоем наружу
- Закрепите саморезами с термошайбами
- Соблюдайте шаг крепления 30-40 см

**Шаг 5: Герметизация**
- Установите торцевые профили
- Заклейте перфорированной лентой нижние торцы листов

### Важные советы

- Не перетягивайте саморезы — оставьте зазор для температурного расширения
- Снимите защитную плёнку после монтажа
- Проверьте работу дверей и форточек

### Профессиональный монтаж

Если у вас нет времени или опыта — закажите монтаж у нас! Профессиональная установка от 3000 ₽ с гарантией.
    `,
    image: "https://images.unsplash.com/photo-1745214149047-b2fe104a9ed7?w=800&q=80",
    date: "2025-06-28",
    category: "Монтаж",
    readTime: 12
  },
  {
    id: 5,
    slug: "ogurtsy-v-teplice",
    title: "Выращивание огурцов в теплице: секреты богатого урожая",
    excerpt: "Всё о выращивании огурцов в теплице: сорта, посадка, формирование, полив и подкормка. Как получить урожай до 15 кг с куста.",
    content: `
## Выращивание огурцов в теплице

Огурцы — идеальная культура для теплицы. При правильном уходе один куст может дать до 15 кг плодов за сезон.

### Лучшие сорта для теплиц

**Партенокарпические (самоопыляемые):**
- Герман F1 — ранний, урожайный
- Кураж F1 — устойчивый к болезням
- Маша F1 — для засолки и салатов

**Пчелоопыляемые:**
- Конкурент — классический засолочный
- Родничок — универсальный

### Подготовка и посадка

- **Сроки посева:** апрель (рассада) или май (в грунт)
- **Температура почвы:** не ниже 16°C
- **Схема посадки:** 40x50 см
- **Глубина:** 2-3 см

### Формирование куста

Для тепличных огурцов важно правильное формирование:
1. Удалите все побеги и завязи в пазухах первых 5 листьев
2. Следующие 5 узлов — оставьте по 1 завязи
3. Выше — по 2-3 завязи
4. На высоте шпалеры прищипните главный стебель

### Полив и подкормка

**Полив:**
- Ежедневно в жару, через день в прохладу
- Только тёплой водой (22-25°C)
- Под корень, не на листья

**Подкормка:**
- Каждые 10-14 дней
- Чередуйте органику и минеральные удобрения
    `,
    image: "https://images.unsplash.com/photo-1692039743891-fc44365e09cb?w=800&q=80",
    date: "2025-06-20",
    category: "Выращивание",
    readTime: 8
  },
  {
    id: 6,
    slug: "obogrev-teplicy",
    title: "Обогрев теплицы: способы отопления весной и осенью",
    excerpt: "Как продлить сезон выращивания с помощью обогрева теплицы. Обзор способов отопления: электрические, газовые, печные.",
    content: `
## Обогрев теплицы: продлеваем сезон

В условиях Башкортостана обогрев теплицы позволяет начать сезон на месяц раньше и продлить его до ноября.

### Способы обогрева

**1. Электрические обогреватели**
- Инфракрасные панели — равномерный нагрев
- Тепловые пушки — быстрый прогрев
- Тёплый пол — для грунта
- Расход: 500-1500 Вт на 10 м²

**2. Печное отопление**
- Буржуйка — бюджетный вариант
- Печь длительного горения — экономичный
- Топливо: дрова, уголь, пеллеты

**3. Водяное отопление**
- Трубы по периметру
- Подключение к домовой системе
- Оптимально для больших теплиц

**4. Биотопливо**
- Навоз, компост под грядками
- Выделяет тепло при разложении
- Естественный и бесплатный способ

### Температурный режим

| Культура | Ночью | Днём |
|----------|-------|------|
| Томаты | 15-17°C | 22-25°C |
| Огурцы | 17-19°C | 24-28°C |
| Перец | 16-18°C | 23-27°C |

### Наши рекомендации

Для теплиц до 20 м² в Башкортостане оптимальны инфракрасные обогреватели с терморегулятором — они экономичны и безопасны.
    `,
    image: "https://images.unsplash.com/photo-1674739969575-e926dc2083ce?w=800&q=80",
    date: "2025-06-15",
    category: "Советы",
    readTime: 7
  }
];

export const reviews = [
  {
    id: 1,
    name: "Александр Петров",
    location: "г. Белебей",
    rating: 5,
    text: "Отличная теплица! Заказывал 'Богатырь' 3x6, привезли и установили за один день. Качество на высоте, рекомендую! Уже второй сезон пользуемся.",
    date: "2025-07-20",
    product: "Теплица 'Богатырь' 3x6 м"
  },
  {
    id: 2,
    name: "Елена Смирнова",
    location: "г. Туймазы",
    rating: 5,
    text: "Третий сезон пользуемся теплицей Премиум. Пережила две снежные зимы без проблем. Очень довольны покупкой, соседи тоже заказали.",
    date: "2025-07-18",
    product: "Теплица 'Премиум' 3x4 м"
  },
  {
    id: 3,
    name: "Рустам Гарипов",
    location: "г. Азнакаево",
    rating: 5,
    text: "Хорошая теплица за свои деньги. Брали Стандарт Усиленная 3x6 - оптимальный вариант. Монтажники всё сделали быстро и качественно.",
    date: "2025-07-15",
    product: "Теплица 'Стандарт Усиленная' 3x6 м"
  },
  {
    id: 4,
    name: "Ольга Новикова",
    location: "г. Бавлы",
    rating: 5,
    text: "Заказывала теплицу Богатырь. Очень красивая и практичная! Муж доволен, что не надо зимой снег чистить - сама скатывается.",
    date: "2025-07-10",
    product: "Теплица 'Богатырь' 3x4 м"
  },
  {
    id: 5,
    name: "Фарит Хасанов",
    location: "г. Октябрьский",
    rating: 5,
    text: "Взяли две теплицы Стандарт Усиленная для дачи. Цена-качество отличное. Доставка была точно в срок.",
    date: "2025-07-08",
    product: "Теплица 'Стандарт' 3x4 м"
  },
  {
    id: 6,
    name: "Гульнара Ахметова",
    location: "с. Бакалы",
    rating: 5,
    text: "Премиум теплица - это действительно премиум! Толстая труба, всё крепкое. Спасибо за качественный товар!",
    date: "2025-07-05",
    product: "Теплица 'Премиум' 3x6 м"
  },
  {
    id: 7,
    name: "Ильдар Сафин",
    location: "с. Шаран",
    rating: 5,
    text: "Брал Богатырь 3x8. Теплица выдержала все ветра и снегопады. Конструкция надёжная, рекомендую!",
    date: "2025-07-01",
    product: "Теплица 'Богатырь' 3x8 м"
  },
  {
    id: 8,
    name: "Марина Валеева",
    location: "с. Буздяк",
    rating: 5,
    text: "Заказали Стандарт Усиленная 3x6. Всё понравилось: и качество, и сервис. Менеджер помог с выбором размера.",
    date: "2025-06-28",
    product: "Теплица 'Стандарт Усиленная' 3x6 м"
  }
];

export const companyInfo = {
  name: "Народные теплицы",
  phone: "+7 (927) 348-24-30",
  phoneClean: "+79273482430",
  email: "narodnyye.teplitsy@mail.ru",
  address: "Республика Башкортостан, г. Туймазы, ул. Мичурина 25/1",
  workHours: "Пн-Пт: 9:00-19:00, Сб-Вс: 10:00-17:00",
  owner: "ИП Мустафин Радис Мударисович",
  social: {
    telegram: "https://t.me/+79273482430",
    whatsapp: "https://wa.me/79273482430",
    max: "https://max.ru/u/f9LHodD0cOL5IaQzWWvOZnhtV2FCZd3JK6QMw9quIQTpiJviZ-Qt4Swi02Q"
  },
  // Доставка
  delivery: {
    regions: ["Республика Башкортостан", "Республика Татарстан"],
    bashkortostan: ["Туймазы", "Октябрьский", "Буздяк", "Белебей", "Приютово", "Ермекеево", "Чекмагуш", "Шаран", "Благоварский р-н", "Бакалы"],
    tatarstan: ["Бавлы", "Ютазы", "Азнакаево", "Бугульма", "Лениногорск"]
  },
  // SEO города
  cities: ["Туймазы", "Октябрьский", "Белебей", "Бавлы", "Азнакаево", "Бакалы", "Шаран", "Буздяк", "Бугульма"],
  region: "Башкортостан и Татарстан",
  regionRod: "Башкортостана и Татарстана",
  regionPredl: "Башкортостане и Татарстане"
};

// Гарантия по типу каркаса
export const warrantyByFrame = {
  '20x20': 3,
  '25x25': 6,
  '40x20': 10
};

export const warrantyDisclaimer = "* Не является публичной офертой. Условия гарантии действительны только при соблюдении гарантийного талона.";

// Опции поликарбоната с ценами по размерам
// priceBySize - для обычных теплиц
// priceBySizeDomikom - для теплиц Домиком
export const polycarbonateOptions = [
  { 
    id: 'eco', 
    name: '3.8 мм', 
    density: '0.42 кг/м²', 
    type: 'Эконом', 
    priceAdd: 0, 
    priceBySize: { "3x4": 0, "3x6": 0, "3x8": 0, "3x10": 0 },
    priceBySizeDomikom: { "3x4": 0, "3x6": 0, "3x8": 0, "3x10": 0 },
    description: 'Бюджетный вариант для южных регионов' 
  },
  { 
    id: 'standard', 
    name: '4 мм', 
    density: '0.52 кг/м²', 
    type: 'Стандарт', 
    priceAdd: 1500, 
    priceBySize: { "3x4": 1500, "3x6": 2000, "3x8": 2500, "3x10": 3000 },
    priceBySizeDomikom: { "3x4": 2000, "3x6": 3000, "3x8": 4000, "3x10": 6000 },
    description: 'Оптимальный выбор цена/качество' 
  },
  { 
    id: 'plus', 
    name: '4 мм', 
    density: '0.6 кг/м²', 
    type: 'Стандарт+', 
    priceAdd: 3000, 
    priceBySize: { "3x4": 3000, "3x6": 3000, "3x8": 4000, "3x10": 5000 },
    priceBySizeDomikom: { "3x4": 4500, "3x6": 5500, "3x8": 7000, "3x10": 9000 },
    description: 'Повышенная прочность для снежных зим' 
  },
  { 
    id: 'premium', 
    name: '4 мм', 
    density: '0.7 кг/м²', 
    type: 'Премиум', 
    priceAdd: 5000, 
    priceBySize: { "3x4": 5000, "3x6": 5000, "3x8": 6000, "3x10": 7000 },
    priceBySizeDomikom: { "3x4": 7000, "3x6": 8500, "3x8": 9500, "3x10": 12000 },
    description: 'Максимальная прочность и долговечность' 
  },
];

// Информация о различиях поликарбоната
export const polycarbonateInfo = {
  title: "Чем отличается поликарбонат?",
  content: [
    { label: "Плотность", text: "Чем выше плотность (кг/м²), тем прочнее поликарбонат и лучше выдерживает снеговые нагрузки." },
    { label: "Эконом (0.42 кг/м²)", text: "Подходит для регионов с мягким климатом. Срок службы 3-5 лет." },
    { label: "Стандарт (0.52 кг/м²)", text: "Универсальный вариант. Выдерживает умеренные снеговые нагрузки. Срок службы 5-7 лет." },
    { label: "Стандарт+ (0.6 кг/м²)", text: "Усиленный поликарбонат для снежных зим. Срок службы 7-10 лет." },
    { label: "Премиум (0.7 кг/м²)", text: "Максимальная прочность. Выдерживает большие снеговые нагрузки. Срок службы 10+ лет." }
  ]
};

// Дополнительные опции с ценами по размерам
export const additionalOptions = {
  fortochka: {
    name: "Дополнительная форточка",
    price: 1500,
    unit: "шт",
    description: "Дополнительная форточка для лучшей вентиляции"
  },
  termoprivod: {
    name: "Термопривод",
    price: 2500,
    unit: "шт",
    description: "Автоматическое открывание форточки при нагреве"
  },
  termoshayby: {
    name: "Термошайбы увеличенные",
    priceBySize: { "3x4": 400, "3x6": 600, "3x8": 800, "3x10": 1000 },
    unit: "комплект",
    description: "Защита поликарбоната от деформации"
  },
  fundament: {
    name: "Фундамент из бруса",
    priceBySize: { "3x4": 3500, "3x6": 4500, "3x8": 5500, "3x10": 7000 },
    unit: "комплект",
    description: "Готовый фундамент из пропитанного бруса 100x100"
  },
  montazh: {
    name: "Монтаж",
    priceBySize: { "3x4": 3000, "3x6": 3500, "3x8": 4500, "3x10": 5000 },
    priceBySizeDomikom: { "3x4": 5000, "3x6": 6000, "3x8": 7000, "3x10": 8000 },
    unit: "услуга",
    description: "Профессиональная сборка и установка"
  },
  gryadki: {
    name: "Грядки оцинкованные",
    priceBySize: { "3x4": 5000, "3x6": 7500, "3x8": 10000, "3x10": 12500 },
    unit: "комплект",
    description: "Оцинкованные грядки для теплицы — долговечные, не гниют"
  }
};

export const advantages = [
  {
    id: 1,
    title: "Собственное производство",
    description: "Изготавливаем теплицы на своём заводе, контролируем качество на всех этапах",
    details: "Все теплицы производятся в Туймазах. Мы лично отвечаем за каждый сварной шов и каждый элемент конструкции."
  },
  {
    id: 2,
    title: "Гарантия до 10 лет",
    description: "Уверены в качестве - даём расширенную гарантию на каркас и поликарбонат",
    details: "Гарантия зависит от модели: Стандарт — 3 года, Богатырь — 6 лет, Премиум — 10 лет. Гарантийный случай решаем за 24 часа."
  },
  {
    id: 3,
    title: "Доставка",
    description: "Доставим по всему Башкортостану и Татарстану: Туймазы, Белебей, Октябрьский, Бавлы и другие города",
    details: "Доставка в радиусе 100 км от Туймазов. Доставка в день заказа или на следующий день."
  },
  {
    id: 4,
    title: "Низкие цены",
    description: "Работаем без посредников - цены от производителя",
    details: "Наши цены на 15-20% ниже рыночных. Без скрытых платежей — указанная цена включает всё, кроме доп.опций."
  }
];

// Уникальные торговые преимущества (УТП)
export const uniqueSellingPoints = [
  "Оцинкованная труба — не ржавеет, служит более 20 лет",
  "UV-защита поликарбоната — не желтеет на солнце",
  "Все соединения на болтах — можно разобрать и перенести",
  "Форточки в комплекте — проветривание с первого дня",
  "Двери с двух сторон — удобный доступ к грядкам",
  "Штыри для крепления — теплица не улетит от ветра"
];

// Почему выбирают нас
export const whyChooseUs = [
  { title: "15+ лет опыта", description: "Работаем с 2010 года, установили более 5000 теплиц" },
  { title: "Местное производство", description: "Производим в Туймазах, знаем климат региона" },
  { title: "Честные цены", description: "Без накруток посредников, только наценка производителя" },
  { title: "Быстрая доставка", description: "Отгрузка в день заказа, доставка за 1-2 дня" },
  { title: "Профессиональный монтаж", description: "Опытные бригады, сборка за 2-4 часа" },
  { title: "Поддержка после покупки", description: "Консультируем по уходу, помогаем с запчастями" }
];

export const standardEquipment = [
  "Две двери с двух сторон",
  "Две форточки",
  "Ручки двусторонние на дверях",
  "Штыри для фиксации к грунту",
  "Комплект крепежа"
];
